export default "__VITE_ASSET__IzLjjGJ8__"